"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearBasketHandler = clearBasketHandler;
var _types = require("../types");
var _utils = require("../utils");
async function clearBasketHandler() {
  const response = await fetch(_types.RequestUrl.ClearBasket, (0, _utils.getHttpRequestSettings)());
  return (0, _utils.convertToCamelCase)(await response.json());
}
